"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCharacters = void 0;
function filterCharacters(rawString, characterWhitelist) {
    var _a;
    if (characterWhitelist === void 0) { characterWhitelist = {}; }
    // If there is not a characterWhitelist, or all the properties are true, empty,
    // and/or undefined, return the original string
    if ((!characterWhitelist.other || characterWhitelist.other.join('').length === 0) &&
        characterWhitelist.special !== false &&
        characterWhitelist.alpha !== false &&
        characterWhitelist.numeric !== false &&
        characterWhitelist.extended !== false) {
        return rawString;
    }
    var newString = rawString;
    var charactersToEscape = [
        '-',
        '/',
        '\\',
        '^',
        '$',
        '*',
        '+',
        '?',
        '.',
        '(',
        ')',
        '|',
        '[',
        ']',
        '{',
        '}',
    ];
    // Compile the 'other' characters into a string safe to add to a RegEx
    var otherWhitelist = ((_a = characterWhitelist.other) === null || _a === void 0 ? void 0 : _a.reduce(function (final, value) {
        return charactersToEscape.includes(value) ? final + '\\' + value : final + value;
    }, '')) || '';
    var characterStrings = {
        // This string identifies the characters to keep. If a character is
        // whitelisted in the 'other' property, then it should be added to this
        // string to preserve it in the output
        extended: '^ -~' + otherWhitelist,
        // The following strings identify the characters to remove. If a character
        // is whitelisted in the 'other' property, then it should be removed from
        // these strings to preserve it in the output
        numeric: '1234567890'.replace(new RegExp("[".concat(otherWhitelist, "]*"), 'g'), ''),
        alpha: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.replace(new RegExp("[".concat(otherWhitelist, "]*"), 'g'), ''),
    };
    for (var key in characterStrings) {
        if (characterWhitelist[key] === false) {
            newString = newString.replace(new RegExp("[".concat(characterStrings[key], "]"), 'g'), '');
        }
    }
    if (characterWhitelist.special === false) {
        var SPECIAL_CHARACTERS = [
            '-',
            '~',
            '`',
            '!',
            '@',
            '#',
            '$',
            '%',
            '^',
            '&',
            '*',
            '(',
            ')',
            '-',
            '_',
            '=',
            '+',
            '[',
            ']',
            '{',
            '}',
            '|',
            '\\',
            '/',
            ';',
            ':',
            "'",
            '"',
            ',',
            '.',
            '<',
            '>',
            '?',
            ' ',
        ];
        // Identify the special characters to remove.
        var specialChars = SPECIAL_CHARACTERS.filter(function (char) { var _a; return !((_a = characterWhitelist.other) === null || _a === void 0 ? void 0 : _a.includes(char)) || false; });
        var escapedSpecialChars = specialChars.reduce(function (final, char) {
            return charactersToEscape.includes(char) ? final + '\\' + char : final + char;
        }, '');
        newString = newString.replace(new RegExp("[".concat(escapedSpecialChars, "]*"), 'gu'), '');
    }
    return newString;
}
exports.filterCharacters = filterCharacters;
